/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DisconnectedComponentConfigSpec } from './disconnectedComponentConfigSpec';
import { SignedConfigResponseSignature } from './signedConfigResponseSignature';


export interface DisconnectedSignedConfigResponse { 
    config?: DisconnectedComponentConfigSpec;
    signature?: SignedConfigResponseSignature;
}

